export default __webpack_public_path__ + "static/media/portfolio-201.8fc9fe5e.jpg";